<template>
  <div>
    <div class="top-padding">
      <div class="page-top">
        <div class="page-top-inner-wrap">
          <h1 class="page-title" tabindex="0">{{title}}</h1>

          <!-- 사용 중인 이용권이 있을 경우-->
          <div class="btn-wrap" v-if="isViewVoucherButton">
            <a href="#" @click.prevent="moveToVoucher()"
                  class="btn btn-large btn-radius btn-positive">이용권 변경하기</a>
          </div>
        </div>
      </div>
    </div>
    <my-pooq-menu-sub v-if="hasSubMenu"></my-pooq-menu-sub>
  </div>
</template>

<script>
import _, { get } from 'lodash'
  import MyPooqMenuSub from '@/components/common/MyPooqMenuSub'
  import { PATH_NAME_VOUCHER_INDEX } from '@/common/resources/router.const'
  import { USED_SUBSCRIPTION_TICKET } from '@/common/utils/eventbus.const'
  export default {
    name: 'MYPooqTitle',
    components: {
      MyPooqMenuSub
    },
    data () {
      return {
        isViewVoucherButton: false,
        subscription: {}
      }
    },
    computed: {
      title () {
        return _.get(this.$route, 'meta.title', '')
      },
      hasSubMenu () {
        return _.get(this.$route, 'meta.menu', '') !== ''
      }
    },
    methods: {
      moveToVoucher () {
        const alertText = (device) => {
          return `${device} 앱 내 구매 이용권은 ${device} 페이지에서만 변경 가능합니다.`
        }
        const isIos = get(this.subscription, 'paymentmethod', '').startsWith('iTunes')
        const isGoogle = get(this.subscription, 'paymentmethod', '').startsWith('구글')
        if (isIos || isGoogle) {
          isIos ? alert(alertText('IOS')) : alert(alertText('google'))
          return
        }
        this.$router.push({ name: PATH_NAME_VOUCHER_INDEX })
      },
      voucherChangeButtonView (subscription) {
        this.isViewVoucherButton = true
        this.subscription = subscription
      }
    },
    created () {
      this.$events.$on(USED_SUBSCRIPTION_TICKET, this.voucherChangeButtonView)
    }
  }
</script>
